import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Navigate } from "react-router-dom";

import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default class AddExams extends Component {
  state = {
    exam_name: "",
    exam_date: "",
    exam_type: "",
    exam_venue: "",
    exam_poster: null,
    description: "",
    status: "inactive",

    // exam result
    result_url: "",
    result_declared_on: "",
    result_file: null, // single result document

    // multiple exam documents (files)
    exam_documents: [], // File[]

    message: "",
    notification: false,
    notiColor: "success",
    redirect: false,
    loading: false,
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleDescription = (content) => {
    this.setState({ description: content });
  };

  handleExamDocumentsChange = (e) => {
    const files = Array.from(e.target.files || []);
    this.setState({ exam_documents: files });
  };

  handleResultFileChange = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    this.setState({ result_file: file });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const {
      exam_name,
      exam_date,
      exam_type,
      exam_venue,
      exam_poster,
      description,
      status,
      result_url,
      result_declared_on,
      exam_documents,
      result_file,
    } = this.state;

    if (!exam_name || !exam_date || !exam_type) {
      this.setState({
        notification: true,
        notiColor: "warning",
        message: "Exam name, date and type are required!",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 3000);
      return;
    }

    const fd = new FormData();
    fd.append("exam_name", exam_name);
    fd.append("exam_date", exam_date);
    fd.append("exam_type", exam_type);
    fd.append("exam_venue", exam_venue);
    fd.append("description", description);
    fd.append("status", status);

    if (exam_poster) {
      fd.append("exam_poster", exam_poster);
    }

    // multiple exam documents from one input
    if (exam_documents && exam_documents.length > 0) {
      exam_documents.forEach((file) => {
        fd.append("exam_documents", file);
      });
    }

    // result metadata
    fd.append(
      "exam_result",
      JSON.stringify({
        result_url: result_url || "",
        declared_on: result_declared_on || null,
      })
    );

    // result document file
    if (result_file) {
      fd.append("result_file", result_file);
    }

    if (init() === "success") {
      this.setState({ loading: true });

      axios
        .post(Constants.postUrls.createExam, fd)
        .then((resp) => {
          this.setState({
            notification: true,
            notiColor: "success",
            message: resp.data?.message || "Exam created successfully!",
            loading: false,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            notiColor: "warning",
            message: err?.response?.data?.message || "Failed to create exam",
            loading: false,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/exams" />;
    } else {
      const { exam_documents } = this.state;

      return (
        <div>
          <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Create Competitive Exam
                  </MDTypography>
                </MDBox>

                <MDBox py={3} px={2}>
                  <form onSubmit={this.handleSubmit}>
                    <Grid container sm={12} spacing={2}>
                      {/* Exam Name */}
                      <Grid item sm={6}>
                        <TextField
                          type="text"
                          label="Exam Name"
                          name="exam_name"
                          onChange={this.handleInput}
                          value={this.state.exam_name}
                          required
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid>

                      {/* Exam Date */}
                      <Grid item sm={6}>
                        <TextField
                          type="datetime-local"
                          label="Exam Date"
                          name="exam_date"
                          onChange={this.handleInput}
                          value={this.state.exam_date}
                          InputLabelProps={{ shrink: true }}
                          required
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid>

                      {/* Exam Type */}
                      <Grid item sm={6}>
                        <InputLabel>Select Exam Type</InputLabel>
                        <Select
                          value={this.state.exam_type}
                          onChange={(e) => this.setState({ exam_type: e.target.value })}
                          name="exam_type"
                          label="Select Exam Type"
                          required
                          style={{ width: "100%", height: "45px", color: "#111" }}
                        >
                          <MenuItem value="">Select Exam Type</MenuItem>
                          <MenuItem value="online" style={{ color: "#111" }}>
                            Online
                          </MenuItem>
                          <MenuItem value="offline" style={{ color: "#111" }}>
                            Offline
                          </MenuItem>
                          <MenuItem value="mixed" style={{ color: "#111" }}>
                            Mixed
                          </MenuItem>
                        </Select>
                      </Grid>

                      {/* Exam Venue */}
                      <Grid item sm={6}>
                        <TextField
                          type="text"
                          label="Exam Venue"
                          name="exam_venue"
                          onChange={this.handleInput}
                          value={this.state.exam_venue}
                          style={{ width: "100%", height: "100%", top: "12px" }}
                        />
                      </Grid>

                      {/* Exam Poster */}
                      <Grid item sm={6}>
                        <TextField
                          type="file"
                          label="Exam Poster"
                          name="exam_poster"
                          focused
                          onChange={(e) => {
                            this.setState({
                              exam_poster: e.target.files[0],
                            });
                          }}
                          style={{ width: "100%", height: "100%", top: "12px" }}
                        />
                      </Grid>

                      {/* Status */}
                      <Grid item sm={6}>
                        <InputLabel>Select Status</InputLabel>
                        <Select
                          value={this.state.status}
                          onChange={(e) => this.setState({ status: e.target.value })}
                          name="status"
                          label="Select Status"
                          style={{ width: "100%", height: "45px", color: "#111" }}
                        >
                          <MenuItem value="inactive" style={{ color: "#111" }}>
                            Inactive
                          </MenuItem>
                          <MenuItem value="active" style={{ color: "#111" }}>
                            Active
                          </MenuItem>
                        </Select>
                      </Grid>

                      {/* Result URL */}
                      {/* <Grid item sm={6}>
                        <TextField
                          type="text"
                          label="Result URL (Optional)"
                          name="result_url"
                          onChange={this.handleInput}
                          value={this.state.result_url}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid> */}

                      {/* Result Declared On */}
                      <Grid item sm={6}>
                        <TextField
                          type="date"
                          label="Result Declared On (Optional)"
                          name="result_declared_on"
                          onChange={this.handleInput}
                          value={this.state.result_declared_on}
                          InputLabelProps={{ shrink: true }}
                          style={{ width: "100%", height: "100%", top: "13px" }}
                        />
                      </Grid>

                      {/* Result Document Upload */}
                      <Grid item sm={6}>
                        <InputLabel>Result Document (Optional)</InputLabel>
                        <TextField
                          type="file"
                          name="result_file"
                          focused
                          onChange={this.handleResultFileChange}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid>

                      {/* Exam Documents */}
                      <Grid item sm={12}>
                        <MDTypography variant="button" fontWeight="bold">
                          Exam Documents (Upload Multiple)
                        </MDTypography>
                      </Grid>

                      <Grid item sm={12}>
                        <TextField
                          type="file"
                          name="exam_documents"
                          inputProps={{ multiple: true }}
                          focused
                          onChange={this.handleExamDocumentsChange}
                          style={{ width: "100%", height: "100%" }}
                        />
                        {exam_documents && exam_documents.length > 0 && (
                          <MDTypography
                            variant="caption"
                            color="text"
                            style={{ display: "block", marginTop: 8 }}
                          >
                            {exam_documents.length} file(s) selected
                          </MDTypography>
                        )}
                      </Grid>

                      {/* Description */}
                      <Grid item sm={12}>
                        <MDTypography variant="button" fontWeight="bold">
                          Description
                        </MDTypography>
                        <SunEditor
                          setDefaultStyle="font-family: Arial; font-size: 16px;"
                          setOptions={{
                            buttonList: [
                              ["undo", "redo"],
                              ["font", "fontSize"],
                              ["paragraphStyle", "blockquote"],
                              ["bold", "underline", "italic", "strike", "subscript", "superscript"],
                              ["fontColor", "hiliteColor"],
                              ["align", "list", "lineHeight"],
                              ["outdent", "indent"],
                              ["table", "horizontalRule", "link", "image", "video"],
                              ["imageGallery"],
                              ["preview", "print"],
                              ["removeFormat"],
                            ],
                            defaultTag: "div",
                            height: 120,
                            showPathLabel: false,
                          }}
                          name="description"
                          setContents={this.state.description}
                          onChange={this.handleDescription}
                        />
                      </Grid>
                    </Grid>

                    <Grid align="left" mt={2}>
                      <MDButton variant="contained" size="small" color="info" type="submit">
                        {this.state.loading ? "Creating..." : "Create"}
                      </MDButton>
                    </Grid>
                  </form>
                </MDBox>

                <MDSnackbar
                  color={this.state.notiColor}
                  icon="notifications"
                  title="Competitive Exams Admin"
                  content={this.state.message}
                  dateTime="Just now"
                  open={this.state.notification}
                />
              </Card>
            </MDBox>
          </DashboardLayout>
        </div>
      );
    }
  }
}
